<template>
  <div class="f20 color-grey">
    <div class="row">
      <div class="col-lg-6">
        <div class="likeButton">
          <font-awesome-icon
            @click="changeStatus(true,1)"
            :class="{'color-like': amount_like > amount_deslike, pointer: !recruiter}"
            icon="thumbs-up"
          ></font-awesome-icon>
          <span class="badge color-white bg-secondary">{{amount_like}}</span>
        </div>
        <div class="likeButton mt-1">
          <font-awesome-icon
            @click="changeStatus(false,1)"
            :class="{'color-dislike': amount_like < amount_deslike, pointer: !recruiter}"
            icon="thumbs-down"
          ></font-awesome-icon>
          <span class="badge color-white  bg-secondary">{{amount_deslike}}</span>
        </div>
      </div>
      <div class="col-lg-6 ">
        <div class="ml-2 likeButton">
          <font-awesome-icon
            @click="changeStatus(true,2)"
            :class="{'color-star': amount_star > 0, pointer: !recruiter}"
            icon="star"
          ></font-awesome-icon>
          <span class="badge color-white bg-secondary">{{amount_star}}</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: [
    "apply_id",
    "job_id",
    "recruiter",
    "like_avaliation",
    "like_candidate",
    "deslike_candidate",
    "star_candidate",
  ],
  data: () => ({
    like: false,
    dislike: false,
    star: false,
    amount_like: 0,
    amount_star: 0,
    amount_deslike: 0,
    amount_star: 0,
  }),
  mounted() {
    this.like_avaliation == 1 ? (this.like = true) : false;
    this.star_candidate >= 1 ? (this.star = true) : false;
    this.like_avaliation == 0 ? (this.dislike = true) : false;
    this.amount_like = this.like_candidate;
    this.amount_deslike = this.deslike_candidate;
    this.amount_star = this.star_candidate;
  },
  methods: {
    changeStatus(status, type_avaliation) {
      if (this.recruiter) {
        return;
      }

      if (status) {
        this.dislike = false;
        if (this.like) {
          this.like = false;
        } else {
          this.like = true;
        }

        this.updateRecord(type_avaliation);
        return;
      }
      this.like = false;
      this.dislike ? (this.dislike = false) : (this.dislike = true);

      this.updateRecord(type_avaliation);
    },
    updateRecord(type_avaliation) {
      let like_avaliation = null;
      this.like ? (like_avaliation = 1) : false;
      this.dislike ? (like_avaliation = 0) : false;

      let url = "/shortlist_managers/change_status_like";
      if (top.location.href.indexOf("?account_uid=") > -1) {
        let account_uid = top.location.href.slice(
          top.location.href.indexOf("?account_uid=") + 13
        );
        url += `?account_uid=${account_uid}`;
      }
      axios
        .put(url, {
          applies: {
            apply_id: this.apply_id,
            job_id: this.job_id,
            like_avaliation: like_avaliation,
            type_avaliation: type_avaliation,
          },
        })
        .then((response) => {
          console.log(response.data);
          this.amount_like = response.data.like_candidate;
          this.amount_deslike = response.data.deslike_candidate;
          this.amount_star = response.data.star_candidate;
        });
    },
  },
};
</script>

<style>
</style>